// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l50ir","largestCol":"styles_largestCol__7YCAY","smallestCol":"styles_smallestCol__3UAkN"};